import C from './component';
import './style.css';

export default C;
